
import { toast } from "react-toastify";
const url = `${process.env.REACT_APP_BASEURL}/api/auth/admin/login`;

export const UserLoginApi = async (formData) => {

    console.log(formData);
     
    try {
        const response = await fetch(
            url,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json", 
                },
                body: JSON.stringify(formData),
            }
        );

        return response;
    } catch (error) {
        toast.error("Something went wrong");
        console.error(error, "Error submitting form:");
    }
};